import { webapi, type WebapiEndpointBuilder } from '@/api/webapi.ts';
import { logger } from '@/components/SgwtBootstrap/logger.ts';

const sendHelpRequest = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<string, SendHelpRequestRequest>({
    query: (params) => ({
      url: '/help/request/v2',
      method: 'POST',
      body: generateBody(params),
      timeout: 30000, // 30 seconds
    }),
  });
};

export const helpRequestApi = webapi.injectEndpoints({
  endpoints: (builder) => ({
    sendHelpRequest: sendHelpRequest(builder),
  }),
});

export type SendHelpRequestRequest = {
  config?: HelpRequestConfig;
  screenshot?: string;
  details?: string;
  data?: Record<string, unknown>;
  templateIdConfirmation?: number;
  templateId?: number;
};

export type SendHelpRequestBody = {
  application: 'SGME-FX';
  config?: HelpRequestConfig;
  userAgent: string;
  probableConnection: 'Remote Desktop' | 'Direct';
  details?: string;
  screenshot?: string;
  data?: Record<string, unknown>;
  templateIdConfirmation?: number;
  templateId?: number;
};

export type HelpRequestConfig = 'general' | 'access' | 'appcrashed' | 'timeouteddeal' | 'orderpending';

const generateBody = (params: SendHelpRequestRequest): SendHelpRequestBody => {
  const isProbablyUsingRemoteDesktop = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const probableConnection = isProbablyUsingRemoteDesktop() ? 'Remote Desktop' : 'Direct';
  const { userAgent } = navigator;

  logger.logInformation(
    'Sending help request {helpRequestBody}',
    JSON.stringify({
      application: 'SGME-FX',
      config: params.config ?? 'general',
      userAgent,
      probableConnection,
      details: params.details,
      screenshot: params.screenshot,
      data: params.data,
    }),
  );

  return {
    application: 'SGME-FX',
    config: params.config ?? 'general',
    userAgent,
    probableConnection,
    screenshot: params.screenshot,
    details: params.details,
    data: params.data,
    templateIdConfirmation: params.templateIdConfirmation,
    templateId: params.templateId,
  };
};

export const { useSendHelpRequestMutation } = helpRequestApi;
